import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import UserCalendars from './UserCalendars'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { enterKeyHandler } from '../../../utils'
import FormSubmitButton from '../FormSubmitButton'
import FormHeading from '../FormHeading'

export default function NewCalendarReportForm() {
  console.log('NewCalendarReport rendered')
  const init = {
    calendar: ''
  }

  const navigate = useNavigate()
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('NewCalendarReportForm.submitSearch', inputs)
    navigate(`/create/${inputs.calendar}`)
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <Table bordered className="custom-table">
          <FormHeading headingText='Choose a calendar...' />
          <tbody>
            <tr>
              <td><b>Calendar</b></td>
              <td><UserCalendars handleChange={handleInputChange} /></td>
            </tr>
          </tbody>
        </Table>
        <FormSubmitButton label="Create Item" />
      </form>
    </div>
  )
}